<template>
	<CampaignLayout :subtitle="trans('tools.campaigns.instances')" :campaign="campaign">
		<Pagination :resource="instances"/>
		<Empty v-if="instances.data.length === 0"/>
		<CardGrid v-else>
			<Card v-for="instance in instances.data" :key="`mail-${instance.id}`" :title="dayjs(instance.created_at).format(trans('general.dayjs.datetime'))">
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('tools.campaigns.instances.show', {campaign: campaign.id, instance: instance.id})">
						<i class="fa-solid fa-eye mr-2"/>
						{{ transChoice('tools.campaigns.mails.recipients.count', instance.recipients_count) }}
					</Link>
				</template>
			</Card>
		</CardGrid>
		<Pagination :resource="instances"/>
	</CampaignLayout>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import {trans, transChoice} from 'laravel-vue-i18n'
import Pagination from '@/Components/UI/Pagination.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import CampaignLayout from '@/Layouts/CampaignLayout.vue'
import {type Campaign} from '@/Types/Tools/Campaigns/Campaign'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type CampaignInstance} from '@/Types/Tools/Campaigns/CampaignInstance'

const props = defineProps<{
	campaign:Campaign,
	instances:PaginatedModel<CampaignInstance>,
}>()

const instances:Ref<PaginatedModel<CampaignInstance>> = ref(props.instances)
</script>